export default __webpack_public_path__ + "static/media/arrow.3166d196.svg";